// 관리자 화면 공통 상단 헤더.
// 제목 + (선택)설명 + 우측 액션 영역을 일관된 간격/타이포로 배치한다.
// 모든 관리자 페이지가 동일한 시작부를 갖게 해 화면 간 통일감을 준다.

import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

// 화면 제목/설명/액션을 표준 레이아웃으로 표시.
export default function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <header className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-col gap-1">
        <h2 className="text-xl font-bold text-ink-900">{title}</h2>
        {description ? <p className="text-sm text-ink-600">{description}</p> : null}
      </div>
      {actions ? (
        <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">{actions}</div>
      ) : null}
    </header>
  );
}
